import { Component, OnInit, ViewChild, Inject, TemplateRef, AfterViewInit, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ContextMenuService } from 'ngx-contextmenu';
import { GfoService, Gfo, ColumnFilter } from 'app/services/gfo.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { CommonTableService, TableRow, TableColumn } from 'app/services/common-table.service';
import { NagService, NagCategory, NagNameAlias, NagPlaceType } from 'app/services/nag.service';
import { PagingParam } from 'app/services/common-request.service';
import { CommonDatagridComponent, TableContextmenuData } from 'app/components/common-datagrid/common-datagrid.component';
import { AppinfoService } from 'app/services/appinfo.service';
import { CommonMapService } from 'app/services/common-map.service';
import { NagStandardModalData, NagStandardModalComponent, NagStandardModalOutput, PlaceType } from './nag-standard-modal/nag-standard-modal.component';
import { MatDialogConfig } from '@angular/material';
import { ConfirmModalData, ConfirmModalComponent } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { NagAliasModalData, NagAliasModalComponent } from './nag-alias-modal/nag-alias-modal.component';

import Feature from 'ol/Feature';
import { Point } from 'ol/geom';
import olMap from 'ol/Map';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Fill, RegularShape, Style } from 'ol/style';
import OSM from 'ol/source/OSM';
import View from 'ol/View';
import Projection from 'ol/proj/Projection';
import { CommonFunctionService } from 'app/services/common-function.service';
import { UserService } from 'app/services/user.service';
import { DomainService } from 'app/services/domain.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import XYZ from 'ol/source/XYZ';

// interface NagType {
// 	label: string;
// 	isSpatial: boolean;
// }

interface CountyItem {
	name: string;
	stnId;
}

@Component({
	selector: 'app-config-nag',
	templateUrl: './config-nag.component.html',
	styleUrls: ['./config-nag.component.css']
})
export class ConfigNagComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('namesTable', { static: false }) namesTable: CommonDatagridComponent;
	@ViewChild('placeTypeTempl', { static: false }) placeTypeTempl: TemplateRef<any>;
	@ViewChild('ownerCellTempl', { static: false }) ownerCellTempl: TemplateRef<any>;
	@ViewChild('operationTempl', { static: false }) operationTempl: TemplateRef<any>;
	// Context menu
	@ViewChild('AliasOptions', { static: false }) aliasContextmenu;
	@ViewChild('StandardOptions', { static: false }) standardContextmenu;

	filterStr = '';
	// Selected nag category
	selectedCate: NagCategory;
	// Nag category list
	nagCates: NagCategory[] = [];
	// nagCateTypes: NagType[] = [{
	// 	label: 'Spatial',
	// 	isSpatial: true
	// }, {
	// 	label: 'Non-Spatial',
	// 	isSpatial: false
	// }];
	// selectedNagCateType: NagType;

	// Standard names table
	// The standard nag names of the selectedCate
	standardNames: TableRow[] = [];
	columns: TableColumn[] = [];
	totalCount: number;
	tableElemId = 'standardNamesTable';
	paging: PagingParam = {
		pageNumber: 1,
		pageSize: 50,
		rowCount: 0
	};
	selectedRows: any[] = [];
	// Alias names
	aliasNames: NagNameAlias[] = [];

	//
	public placeTypes: NagPlaceType[] = [];
	// Contextmenu options enable/disable
	public optionsEnable: any = {};

	// Map
	public map; // ol.Map;
	public mapId = 'nag-map';
	public placeLayer; // ol.layer.Vector;
	hideMap = false;

	selectedState: {
		code: string;
	} = {
		code: null
	}
	stateList: {code:string}[] = [];
	showCountyFilter: boolean
	filterCounty: CountyItem;
	availableCounties: CountyItem[];

	canAddAlias = false;

	// stateSvgSrc = 'src/assets/css/img/icon_building_government.svg';
	// countySvgSrc = 'src/assets/css/img/icon_building_government_2.svg';
	// citySvgSrc = 'src/assets/css/img/icon_flag.svg';

	private cusId: number;

	private hasStComponentChanged: boolean;

	// County category
	private nagCateCounty: NagCategory;
	// Hard code columns
	private stnNameCol: string;
	private stnIdCol: string;
	private standardSourceCol = 'stn_source';
	private standardOwnerAgencyCol = 'stn_cus_id';
	private placeNameCountyCol = 'stn_name_parent';
	private geomCol = 'geom';
	centroidCol: string;
	private parentIdCol = 'stn_parent_id'; // TODO
	public placeTypesCol = 'place_types';
	ownerLevelCol = 'level';
	ownerLevelIconCol = 'levelIcon';
	operationCol = 'op';
	cusNameShortCol = 'cus_name_short';

	placeNameCateName: string;
	private countyCateName = 'COUNTY';
	//
	private filterStrTimeout: any;
	//
	constructor(
		@Inject(DOCUMENT) private document: Document,
		private elemRef: ElementRef,
		private contextmenuService: ContextMenuService,
		private toastr: ToastrService,
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private cMapService: CommonMapService,
		private commonService: CommonFunctionService,
		private modalService: CommonModalService,
		private tableService: CommonTableService,
		private domainService: DomainService,
		private gfoService: GfoService,
		private qcService: LayerQcService,
		private nagService: NagService,
		private userService: UserService
	) { }

	@HostListener('window:beforeunload', ['$event'])
	onWindowUnload() {
		this.onLeave();
		debugger
	}

	// async onChangeNagCateType() {
	// 	const nagCate = this.nagCates.find(i => i.isSpatial === this.selectedNagCateType.isSpatial);
	// 	if (nagCate) {
	// 		await this.selectCate(nagCate);
	// 	}
	// }
	async selectCate(nag: NagCategory) {
		// Clear
		if (this.placeLayer) {
			this.placeLayer.getSource().clear();
		}
		this.canAddAlias = false;

		if (nag.name === this.placeNameCateName) {
			await this.getAvailableCountyList();
			this.showCountyFilter = true;
		} else {
			this.showCountyFilter = false;
		}
		this.selectedCate = nag;
		this.hideMap = !this.selectedCate || !this.selectedCate.isSpatial;
		// Clear filter
		this.filterStr = '';
		// Reset paging parameters
		this.paging.rowCount = 1; // Request total count
		this.paging.pageNumber = 1;
		// Get standard nag names
		await this.getNagNamesStandard();
		// Update table paging
		setTimeout(() => this.namesTable.reset(1, this.totalCount));
	}
	private async getNagNamesStandard() {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const gfo = this.getSearchStrGfo();
			const rsp = await this.nagService.getNagNamesStandard(this.selectedCate.id, this.selectedState.code, gfo, this.paging);
			// Clear alias list
			this.aliasNames = [];
			// Update total count if requested
			if (this.paging.rowCount > 0) {
				this.totalCount = rsp.totalCount;
			}
			// Update table
			this.standardNames = rsp.data;
			if (this.standardNames.length) {
				// this.columns = this.tableService.setColumnsFromRows(this.standardNames);
				const keys = Object.keys(this.standardNames[0]);
				this.columns = keys.map(k => {
					const col = this.tableService.setNewColumn(k, null, {
						align: 'C'
					});
					col.width = 80;
					return col;
				});
				// Owner column
				const ownerLevelIconCol = this.tableService.setNewColumn(this.ownerLevelIconCol, 'Owner', {
					width: 40,
					cellTemplate: this.ownerCellTempl
				});
				ownerLevelIconCol.info.skipSmartDisplay = true;
				this.columns.unshift(ownerLevelIconCol);
				// Change labels for stn_name / stn_name_parent
				if (rsp.misc) {
					Object.keys(rsp.misc).forEach(i => {
						const col = this.columns.find(c => c.prop === i);
						if (col) {
							col.name = rsp.misc[i];
						}
					})
				}
				// Hide centroid column
				const centroidColIdx = this.columns.findIndex(c => c.prop === this.centroidCol);
				if (centroidColIdx) {
					this.columns.splice(centroidColIdx, 1);
					// this.tableService.hideColumn(centroidCol);
				}
				// Add place types columns if needed
				if (this.standardNames[0] && this.standardNames[0][this.placeTypesCol]) {
					// Remove the placeTypes col from columns
					const placeColIdx = this.columns.findIndex((c) => c.prop === this.placeTypesCol);
					this.columns.splice(placeColIdx, 1);
					// Add place types columns
					this.placeTypes.forEach((t) => {
						const col = this.tableService.setNewColumn(t.name, null, {
							cellTemplate: this.placeTypeTempl,
							align: 'C',
							width: 70
						});
						col.info.skipSmartDisplay = true;
						this.columns.push(col);
					});
				}
				// Operation column
				const operationCol = this.tableService.setNewColumn(this.operationCol, ' ', {
					width: 25,
					cellTemplate: this.operationTempl
				});
				this.columns.unshift(operationCol);
				operationCol.info.skipSmartDisplay = true;
				// Hide cusShort and level column
				const cusShortIdx = this.columns.findIndex(c => c.prop === this.cusNameShortCol);
				if (cusShortIdx > -1) {
					this.columns.splice(cusShortIdx, 1);
				}
				const levelColIdx = this.columns.findIndex(c => c.prop === this.ownerLevelCol);
				if (levelColIdx > -1) {
					this.columns.splice(levelColIdx, 1);
				}
				const cusIdColIdx = this.columns.findIndex(c => c.prop === this.standardOwnerAgencyCol);
				if (cusIdColIdx > -1) {
					this.columns.splice(cusIdColIdx, 1);
				}
					// // Calc width
					// this.tableService.updateColumnsSmartDisplay(this.standardNames, this.columns);
				// Full width
				if (this.selectedCate.name !== this.countyCateName) {
					setTimeout(() => {
						this.tableService.extendTableFull(this.elemRef, this.tableElemId, this.columns, true);
						this.columns = this.columns.map(i => i);
					});
				}
				// Uppercase
				this.columns.forEach(c => c.name = c.name.toUpperCase());
			}
		} catch (err) {

		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	changeFilter() {
		if (this.filterStrTimeout) {
			clearTimeout(this.filterStrTimeout);
		}
		// Wait for 500 ms before searching for what user inputs
		this.filterStrTimeout = setTimeout(async () => {
			await this.getNagNamesStandard();
			// Update table paging
			setTimeout(() => this.namesTable.reset(1, this.totalCount));
		}, 500);
	}
	async filterByCounty() {
		await this.getNagNamesStandard();
	}

	async download() {
		const gfo = this.getSearchStrGfo();
		this.nagService.getNagNamesStandard(this.selectedCate.id, this.selectedState.code, gfo, {
			pageNumber: 0
		}).then((rsp) => {
			if (!rsp.data.length) {
				this.toastr.info('No data to download.');
				return;
			}
			const columns: TableColumn[] = [];
			const data: string[] = [];

			// Get columns
			if (this.columns.length) {
				let datum = '';
				this.columns.forEach((col) => {
					if (col.isDisplay) {
						columns.push(col);
						datum += col.name + '\t';
					}
				});
				// Remove the last tab
				datum = datum.slice(0, -1);
				datum += '\n';
				data.push(datum);
			}

			// Get rows
			rsp.data.forEach((r) => {
				let datum = '';
				// Get place types
				if (this.selectedCate.name === this.placeNameCateName) {
					const placeTypes = r[this.placeTypesCol];
					placeTypes.forEach((p) => {
						r[p] = '\u2713'; // place a check mark for existing place type
					});
				}
				for (const col of columns) {
					if (!r[col.prop] && r[col.prop] !== 0) {
						datum += '';
					} else {
						datum += r[col.prop];
					}
					datum += '\t';
				}

				datum = datum.slice(0, -1);
				datum += '\n';
				data.push(datum);
			});

			// Create download blob
			const blob = new Blob(data, { type: 'text/csv' });
			const url = URL.createObjectURL(blob);
			// Download the file with a meaningful name
			const today = new Date();
			const month = this.formatTime(today.getMonth()) + 1;
			const date = this.formatTime(today.getDate());
			const year = this.formatTime(today.getFullYear());

			const anchor = this.document.createElement('a');
			anchor.href = url;
			this.document.body.appendChild(anchor);
			anchor.download = 'NAG-' + this.selectedCate.name + '-' + year + month + date + '.txt';
			// anchor.setAttribute('type', 'hidden');
			anchor.click();
			this.document.body.removeChild(anchor);
		});
	}
	private formatTime(t) {
		if (t < 10) {
			t = '0' + t;
		}
		return t;
	}

	private getSearchStrGfo(): Gfo {
		let filters: ColumnFilter[] = [], gfo: Gfo;
		const searchStr = this.filterStr ? this.filterStr.trim() : '';
		if (searchStr) {
			const filter = this.gfoService.getFilter(this.stnNameCol, this.appinfoService.filterOperators.contains.name, this.filterStr);
			filters.push(filter);
		}
		if (this.showCountyFilter && this.filterCounty) {
			const filter = this.gfoService.getFilter('stn_name_parent', this.appinfoService.filterOperators.eq.name, this.filterCounty.name);
			filters.push(filter);
		}
		if (filters.length) {
			gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, filters);
		}
		return gfo;
	}

	async setPage(pageNum: number) {
		this.paging.pageNumber = pageNum;
		this.paging.rowCount = 0;
		await this.getNagNamesStandard();
	}
	onTableContextmenu(e: TableContextmenuData) {
		if (e.type === 'body') {
			const event = e.event;
			this.contextmenuService.show.next({
				event: event,
				contextMenu: this.standardContextmenu,
				item: e.content
			});
			event.preventDefault();
			event.stopPropagation();
		}
	}
	onTableParentContextmenu(event: MouseEvent) {
		this.contextmenuService.show.next({
			event: event,
			contextMenu: this.standardContextmenu,
			item: null
		});
		event.preventDefault();
		event.stopPropagation();
	}
	onAliasContextmenu(event: MouseEvent, alias?: NagNameAlias) {
		this.contextmenuService.show.next({
			event: event,
			contextMenu: this.aliasContextmenu,
			item: alias
		});
		event.preventDefault();
		event.stopPropagation();
	}
	async onSelectStandardName() {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			this.canAddAlias = this.optionsEnable.aliasAdd();
			//
			const select = this.selectedRows[0];
			this.placeLayer.getSource().clear();
			// Set map range by geom or centroid
			if (select[this.geomCol]) {
				//
			} else if (select[this.centroidCol]) {
				const centroid = select[this.centroidCol].split(' ');
				centroid[0] = Number(centroid[0]);
				centroid[1] = Number(centroid[1]);
				const transformed = this.cMapService.mapUtility.transformProjection('POINT', [centroid[1], centroid[0]], 'EPSG:4326', 'EPSG:3857');
	
				this.placeLayer.getSource().addFeature(new Feature(
					new Point(transformed)
				));
				this.map.getView().setCenter(transformed);
				this.map.getView().setResolution(100);
			}
			// Get alias names of the selected standard name
			this.aliasNames = await this.nagService.getNagNamesAlias(select[this.stnIdCol], this.selectedCate.id);
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}

// Context menu functions
	async addStandardName() {
		const options: MatDialogConfig = {};
		const isSpatial = this.selectedCate.isSpatial;
		const data: NagStandardModalData = {
			action: 'add',
			selectedCate: this.selectedCate
			// isSpatial: isSpatial
		};
		let secondaryNames: string[];
		let placeTypeListBeforeChange: PlaceType[];
		if (this.selectedCate.name === this.placeNameCateName) {
			options.height = '400px';
			options.width = '600px';
			placeTypeListBeforeChange = this.placeTypes.map((pt) => {
				return {
					name: pt.name,
					selected: false
				};
			});
			data.placeTypeList = JSON.parse(JSON.stringify(placeTypeListBeforeChange));
			if (this.nagCateCounty) {
				data.countyList = await this.getAvailableCountyList();
			}
		} else {
			options.height = isSpatial ? '200px' : '230px';
			options.width = '400px';
		}
		options.data = data;
		const result: NagStandardModalOutput = await this.modalService.openModalWindow(NagStandardModalComponent, options);
		if (result) {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				if (isSpatial) {
					await this.nagService.addStandard_location(this.selectedCate.id, result.name, result.placeTypes, result.parentId);
					// Compare changed placeTypes
					const currentPlaceTypeNames = result.placeTypes || [];
					secondaryNames = this.getSecondaryNames(currentPlaceTypeNames, placeTypeListBeforeChange);
				} else {
					await this.nagService.addStandard_street(this.selectedCate.id, result.name, result.source);
				}
				this.toastr.success('Successfully added.');
				this.onCommit(this.selectedCate, secondaryNames);
				// Update standard names
				await this.getNagNamesStandard();
			} catch (err) {
				this.toastr.error('Failed to add standard name.');
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		}
	}
	async editStandardName(e) {
		const standardName = e.item;
		const isSpatial = this.selectedCate.isSpatial;
		const options: MatDialogConfig = {};
		const data: NagStandardModalData = {
			action: 'edit',
			standard: {
				name: standardName[this.stnNameCol],
				source: standardName[this.standardSourceCol]
			},
			selectedCate: this.selectedCate
			// isSpatial: isSpatial
		};
		let placeTypeListBeforeChange: PlaceType[];
		if (this.selectedCate.name === this.placeNameCateName) { // For placeTypes category
			// Add parent county
			data.standard.parentId = standardName[this.parentIdCol];
			// Add place types
			const currPlaceTypes = standardName[this.placeTypesCol];
			placeTypeListBeforeChange = this.placeTypes.map((pt) => {
				return {
					name: pt.name,
					selected: currPlaceTypes.indexOf(pt.name) > -1,
				};
			});
			data.placeTypeList = JSON.parse(JSON.stringify(placeTypeListBeforeChange));
			if (this.nagCateCounty) {
				data.countyList = await this.getAvailableCountyList();
			}
			options.height = '400px';
			options.width = '600px';
		} else {
			options.height = isSpatial ? '200px' : '230px';
			options.width = '400px';
		}
		options.data = data;
		const result: NagStandardModalOutput = await this.modalService.openModalWindow(NagStandardModalComponent, options);
		if (result) {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				let secondaryNames: string[];
				if (isSpatial){
					const currentPlaceTypeNames = result.placeTypes || [];
					secondaryNames = this.getSecondaryNames(currentPlaceTypeNames, placeTypeListBeforeChange);
	
					await this.nagService.editStandard_location(this.selectedCate.id, standardName[this.stnIdCol], result.name, result.placeTypes, result.parentId);
				} else {
					await this.nagService.editStandard_street(this.selectedCate.id, standardName[this.stnIdCol], result.name, result.source);
				}
				this.toastr.success('Successfully updated.');
				this.onCommit(this.selectedCate, secondaryNames);
				// Update standard names
				await this.getNagNamesStandard();
			} catch (err) {
				this.toastr.error('Failed to update standard name.');
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		}
	}
	async deleteStandardName(e) {
		const standard = e.item;
		if (!standard) { return; }
		const options = this.modalService.confirmModalOptions;
		const data: ConfirmModalData = {
			title: 'Confirm',
			message: 'Are you sure you want to delete ' + standard[this.stnNameCol] + '?'
		};
		options.data = data;
		const result = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		// User confirm deletion
		if (result) {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				await this.nagService.deleteStandard(this.selectedCate.id, standard[this.stnIdCol]);
				this.toastr.success(standard[this.stnNameCol] + ' is successfully removed.');
				let secondaryNames: string[] = standard[this.placeTypesCol];
				this.onCommit(this.selectedCate, secondaryNames);
				// Update standard names
				await this.getNagNamesStandard();
			} catch (err) {
				this.toastr.error('Failed to remove ' + standard[this.stnNameCol] + '.');
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		}
	}
	async addAlias() {
		const selectedStandard = this.selectedRows[0];
		if (!selectedStandard) { return; }
		const options: MatDialogConfig = {
			height: '200px',
			width: '400px'
		};
		const data: NagAliasModalData = {
			action: 'add'
		};
		options.data = data;
		const result = await this.modalService.openModalWindow(NagAliasModalComponent, options);
		if (result) {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				await this.nagService.addAlias(this.selectedCate.id, selectedStandard[this.stnIdCol], result);
				this.toastr.success('Successfully added.');
				const secondaryNames = selectedStandard[this.placeTypesCol];
				this.onCommit(this.selectedCate, secondaryNames);
				// Update alias names list
				this.aliasNames = await this.nagService.getNagNamesAlias(selectedStandard[this.stnIdCol], this.selectedCate.id);
			} catch (err) {
				this.toastr.error('Failed to add alias.');
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		}
	}
	async editAlias(e) {
		const alias: NagNameAlias = e.item;
		if (!alias) { return; }
		const options: MatDialogConfig = {
			height: '200px',
			width: '400px'
		};
		const data: NagAliasModalData = {
			action: 'edit',
			alias: alias
		};
		options.data = data;
		const result = await this.modalService.openModalWindow(NagAliasModalComponent, options);
		if (!result) {
			return;
		} else if (result.delete) {
			this.deleteAlias(e);
		} else if (result && result !== alias.name) {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				await this.nagService.editAlias(this.selectedCate.id, alias.id, result);
				const selectedStandard = this.selectedRows[0];
				const secondaryNames = selectedStandard[this.placeTypesCol];
				this.onCommit(this.selectedCate, secondaryNames);
				this.toastr.success('Successfully updated.');
				// Update alias names list
				this.aliasNames = await this.nagService.getNagNamesAlias(alias.stnId, this.selectedCate.id);
			} catch (err) {
				this.toastr.error('Failed to update alias.');
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		}
	}
	async deleteAlias(e) {
		const alias: NagNameAlias = e.item;
		if (!alias) { return; }
		const options = this.modalService.confirmModalOptions;
		const data: ConfirmModalData = {
			title: 'Confirm',
			message: 'Are you sure you want to delete this alias ' + alias.name + '?'
		};
		options.data = data;
		const result = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		// User confirm deletion
		if (result) {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				await this.nagService.deleteAlias(alias.id);
				this.toastr.success(alias.name + ' is successfully removed.');
				const selectedStandard = this.selectedRows[0];
				const secondaryNames = selectedStandard[this.placeTypesCol];
				this.onCommit(this.selectedCate, secondaryNames);
				// Update alias names list
				this.aliasNames = await this.nagService.getNagNamesAlias(alias.stnId, this.selectedCate.id);
			} catch (err) {
				this.toastr.error('Failed to remove alias ' + alias.name + '.');
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		}
	}
	private getSecondaryNames(currPlaceTypeNames: string[], placeTypeListBeforeChange: PlaceType[]) {
		const secondaryNames = [];
		placeTypeListBeforeChange.forEach(p => {
			if (p.selected && currPlaceTypeNames.indexOf(p.name) === -1) {
				secondaryNames.push(p.name);
			} else if (!p.selected && currPlaceTypeNames.indexOf(p.name) > -1) {
				secondaryNames.push(p.name);
			}
		});
		return secondaryNames;
	}

	private async getAvailableCountyList(force?: boolean) {
		if (this.availableCounties && this.availableCounties && !force) {
			return this.availableCounties;
		}
		const availableCounties = this.userService.customerInfo.cusCounties || [];
		const countiesRsp = await this.nagService.getNagNamesStandard(this.nagCateCounty.id, this.selectedState.code, null, { pageNumber: 0 });
		const filtered = availableCounties.length ? countiesRsp.data.filter(d => availableCounties.indexOf(d[this.stnNameCol]) > -1) : countiesRsp.data;
		this.availableCounties = filtered.map((d) => {
			return {
				name: d[this.stnNameCol],
				stnId: d[this.stnIdCol]
			};
		});
		// Update filterCounty
		if (this.filterCounty) {
			this.filterCounty = this.availableCounties.find(i => i.name === this.filterCounty.name)
		} else {
			this.filterCounty = this.availableCounties[0];
		}
		return this.availableCounties;
	}
	private async onLeave() {
		if (this.nagService.changedNctNames && this.nagService.changedNctNames.length) {
			// Do not need to await qc to finish, nor notify the user
			await this.qcService.qcLayerIncNag(this.nagService.changedNctNames);
			// Trigger qc finish, so that layer list will be updated
			this.qcService.onQcFinish.next();
			
			this.nagService.changedNctNames = null;
			//
			if (this.hasStComponentChanged) {
				await this.nagService.updateMvStComponents();
				this.hasStComponentChanged = false;
			}
			await this.domainService.getDomains();
		}
	}
	private onCommit(cate: NagCategory, secondaryNames?: string[]) {
		const nctName = cate.name;
		if (!this.nagService.changedNctNames) {
			this.nagService.changedNctNames = [];
		}
		if (!secondaryNames || !secondaryNames.length) {
			if (this.nagService.changedNctNames.indexOf(nctName) === -1) {
				this.nagService.changedNctNames.push(nctName);
			}
		} else {
			secondaryNames.forEach(secName => {
				const combine = nctName + ':' + secName;
				if (this.nagService.changedNctNames.indexOf(combine) === -1) {
					this.nagService.changedNctNames.push(combine);
				}
			});
		}

		if (!cate.isSpatial) {
			this.hasStComponentChanged = true;
		}
	}

	async ngOnInit() {
		this.stnNameCol = this.attrIndexService.stnNameCol;
		this.stnIdCol = this.attrIndexService.stnIdCol;
		this.centroidCol = this.attrIndexService.centroidCol;
		this.placeNameCateName = this.attrIndexService.placenameNagName;

		const customerInfo = this.userService.customerInfo;
		if (customerInfo.givState) {
			this.selectedState = {
				code: customerInfo.givState
			}
			this.stateList.push(this.selectedState);
		}
		this.cusId = this.userService.getCustomerIdByType();
			// this.selectedNagCateType = this.nagCateTypes[0];
		// Get place types
		this.placeTypes = this.nagService.placeTypes || await this.nagService.getNagSubCategory();
		// Get nag categories
		this.nagCates = await this.nagService.getNagCategories();
		const placeNameIdx = this.nagCates.findIndex(i => i.name === this.attrIndexService.placenameNagName);
		if (placeNameIdx > -1) {
			const placeName = this.nagCates[placeNameIdx];
			this.nagCates.splice(placeNameIdx, 1);
			this.nagCates.unshift(placeName);
		}
		// Set county category
		this.nagCateCounty = this.nagCates.find((c) => c.name === this.countyCateName);
		// Set initial selectedCate
		this.selectCate(this.nagCates[0]);
		//
		this.optionsEnable = {
			standardAdd: () => {
				if (!this.selectedCate || !this.userService.getUserInfo().isAdmin 
				) {
					return false;
				}
				if (this.selectedCate.name === this.attrIndexService.stDirectionCateName) {
					return false;
				}
				if (this.selectedCate.name !== this.countyCateName) {
					return true;
				} else {
					return this.userService.getUserInfo().isSuperAdmin;
				}
			},
			standardEdit: (item) => {
				if (!item || !this.selectedCate || !this.userService.getUserInfo().isAdmin) {
					return false;
				}
				if (this.selectedCate.name === this.attrIndexService.stDirectionCateName) {
					return false;
				}
				if (this.selectedCate.name !== this.countyCateName) {
					if (this.selectedCate.name === this.placeNameCateName) {
						const county = item[this.placeNameCountyCol];
						const availableCounties = this.userService.customerInfo.cusCounties || [];
						const isCountyAvailable = availableCounties.indexOf(county) > -1;
						return item[this.standardOwnerAgencyCol] === this.cusId || (item[this.standardOwnerAgencyCol] === 0 && isCountyAvailable);
					} else {
						return item[this.standardOwnerAgencyCol] === this.cusId;
					}
				} else {
					return this.userService.getUserInfo().isSuperAdmin;
				}
			},
			aliasAdd: () => {
				if (!this.selectedRows[0] || !this.userService.getUserInfo().isAdmin) {
					return false;
				}
				if (this.selectedCate.name === this.countyCateName) {
					return true;
					// return this.userService.getUserInfo().isSuperAdmin;
				} else if (this.selectedCate.isSpatial) { // Place
					return this.selectedRows[0][this.standardOwnerAgencyCol] === this.cusId;
				} else { // Street
					return true;
				}
				
			},
			// Conditions for: Edit & Delete
			aliasEdit: (item: NagNameAlias) => {
				if (!item || !this.userService.getUserInfo().isAdmin) {
					return false;
				}
				// if (this.selectedCate.name !== this.countyCateName) {
				// 	return item.cusId === this.cusId;
				// } else {
				// 	return this.userService.getUserInfo().isSuperAdmin;
				// }
				return item.cusId === this.cusId;
			}
		};
	}
	async ngAfterViewInit() {
		// Set map
		this.placeLayer = new VectorLayer({
			source: new VectorSource(),
			style: new Style({
				image: new RegularShape({
					fill: new Fill({ color: 'red' }),
					points: 5,
					radius: 10,
					radius2: 4,
					angle: 0
				})
			})
		});
		this.map = new olMap({
			target: this.mapId,
			view: new View({
				center: [-10600898.578815, 4799022.383857], // Initial center of map;
				extent: undefined,
				projection: new Projection({
					code: 'EPSG:3857',
					units: 'm'
				}),
				zoom: 3,
				minZoom: 2
			}),
			// Use Open Street Map as base layer
			layers: [
				// new TileLayer({
				// 	source: new OSM()
				// }),
				// this.placeLayer
			]
		});
		const options = {
			title: 'World Street',
			type: 'base',
			source: new XYZ({
				url: 'https://server.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer' + '/tile/{z}/{y}/{x}'
			}),
		};
		const mapLayer = new TileLayer(options);
		this.map.addLayer(mapLayer);
		this.map.addLayer(this.placeLayer);

	}
	async ngOnDestroy() {
		await this.onLeave();
	}
}
